import React from 'react';
import DIcon from './discord-icon-svgrepo-com.svg';

const MyDiscordIcon = () => {
    return <img src={DIcon} alt="Discord icon" width="24" height="20" />;
}

export default MyDiscordIcon;